/**
 * 动态饼图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const dynamicPieValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'date', type: 'date', required: false }
  ],
  businessRules: [
    {
      name: 'dynamic-pie-time-period-data-range',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return false;
        }
        const { encoding } = layer;
        const dateField = encoding?.date || 'date';
        const dates = data.map(d => new Date(d[dateField as string]).getTime());
        return new Set(dates).size > 1;
      },
      message: 'Dynamic pie chart requires data from multiple time periods',
      suggestion: 'Provide data with different date values for animation',
      severity: 'error'
    },
    {
      name: 'dynamic-pie-non-negative-values',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return false;
        }
        const { encoding } = layer;
        return data.every(item => {
          const value = item[encoding?.y as string] as number;
          return value >= 0;
        });
      },
      message: 'Dynamic pie chart values must be non-negative',
      suggestion: 'Ensure all y field values are non-negative numbers',
      severity: 'error'
    },
    {
      name: 'dynamic-pie-unique-categories-per-date',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return false;
        }
        const { encoding } = layer;
        const dateField = encoding?.date || 'date';
        const categoryField = encoding?.x || 'x';

        const dateCategories = new Map<string, Set<string>>();
        data.forEach(item => {
          const date = new Date(item[dateField as string]).toISOString();
          const category = item[categoryField as string] as string;
          if (!dateCategories.has(date)) {
            dateCategories.set(date, new Set());
          }
          dateCategories.get(date)?.add(category);
        });

        for (const categories of dateCategories.values()) {
          if (categories.size > 10) {
            return false; // warning in another rule
          }
        }
        return true;
      },
      message: 'Each time period in dynamic pie chart should have unique categories',
      suggestion: 'Ensure categories are unique within each date',
      severity: 'error'
    }
  ]
};
